import {createFeatureSelector, createSelector} from "@ngrx/store";

export const notificationSelector = createFeatureSelector<any>('notifications');
export const notificationsDataSelector = createSelector(notificationSelector, (state: any) => state);
export const notificationsIsLoaded = createSelector(notificationSelector, (state: any) => state.isLoaded);
